import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {UsersPage} from "../pages/user/UsersPage";
import {PermissionsPage} from "../pages/roles-permissions/PermissionsPage";
import {RolesPage} from "../pages/roles-permissions/RolesPage";
import {useAuth} from "../modules/auth";
import React from "react";
import {OtherSettings} from "../pages/other-settings/OtherSettings";
import {VehiclesPage} from "../pages/vehicle/VehiclesPage";
import {SalesCustomersPage} from "../pages/sales-customers/SalesCustomersPage";
import {SuppliersPage} from "../pages/suppliers/SuppliersPage";
import {InventoryItemsPage} from "../pages/inventory-items/InventoryItemsPage";
import {ServiceItemsPage} from "../pages/inventory-items/ServiceItemsPage";
import {SyncPage} from "../pages/sync/SyncPage";
import {SaleEntryPage} from "../pages/sale/SaleEntryPage";
import {SaleEntryStep1Page} from "../pages/sale/SaleEntryStep1Page";
import {PendingSalesPage} from "../pages/sale/PendingSalesPage";
import {SalesListPage} from "../pages/sale/SalesListPage";
import {EwayBillPrintPage} from "../pages/sale/EwayBillPrintPage";
import {EInvoicePrintPage} from "../pages/sale/EInvoicePrintPage";
import {GstServicesInfoPage} from "../pages/sale/GstServicesInfoPage";
import {SalePrintSummaryPage} from "../pages/sale/SalePrintSummaryPage";
import {PurchaseEntryPage} from "../pages/purchase/PurchaseEntryPage";
import {PurchaseEntryStep1Page} from "../pages/purchase/PurchaseEntryStep1Page";
import {PurchaseViewPage} from "../pages/purchase/PurchaseViewPage";
import {PurchasesListPage} from "../pages/purchase/PurchasesListPage";
import {PendingPurchasesPage} from "../pages/purchase/PendingPurchasesPage";
import {PurchasePrintSummaryPage} from "../pages/purchase/PurchasePrintSummaryPage";
import {LedgerAccountsPage} from "../pages/ledger/LedgerAccountsPage";
import {OrganizationSettingsPage} from "../pages/org-settings/OrganizationSettingsPage";
import {UISettingsPage} from "../pages/ui-settings/UISettingsPage";
import {WeighbridgeSetupPage} from "../pages/weighbridge/WeighbridgeSetupPage";
import {CapturedImagesPage} from "../pages/images/CapturedImagesPage";
import {ExpensesPage} from "../pages/expenses/ExpensesPage";
import {DailyReportPage} from "../pages/daily-report/DailyReportPage";
import {WifiSettingsPage} from "../pages/wifi-settings/WifiSettingsPage";
import {HelpPage} from "../pages/help/HelpPage";
import {StockYardPage} from "../pages/stockyard/StockYardPage";
import {QrAutoPurchaseVehiclesPage} from "../pages/qr-purchase/QrAutoPurchaseVehiclesPage";
import {QrScanLogPage} from "../pages/qr-purchase/QrScanLogPage";
import {DraftPurchasesPage} from "../pages/qr-purchase/DraftPurchasesPage";

const PrivateRoutes = () => {
    const {currentUser} = useAuth();

    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/dashboard'/>}/>

                {/* Dashboard */}
                <Route path='dashboard' element={<DashboardWrapper/>}/>

                <Route path='users' element={<UsersPage/>}/>
                <Route path='roles' element={<RolesPage/>}/>
                <Route path='permissions' element={<PermissionsPage/>}/>

                <Route path='other-settings' element={<OtherSettings/>}/>
                <Route path='vehicles' element={<VehiclesPage/>}/>
                <Route path='sales-customers' element={<SalesCustomersPage/>}/>
                <Route path='suppliers' element={<SuppliersPage/>}/>
                <Route path='inventory-items' element={<InventoryItemsPage/>}/>
                <Route path='service-items' element={<ServiceItemsPage/>}/>
                <Route path='ledger-accounts' element={<LedgerAccountsPage/>}/>
                <Route path='sales-list' element={<SalesListPage/>}/>
                <Route path='eway-print/:saleId' element={<EwayBillPrintPage/>}/>
                <Route path='einvoice-print/:saleId' element={<EInvoicePrintPage/>}/>
                <Route path='gst-services-info' element={<GstServicesInfoPage/>}/>
                <Route path='sync' element={<SyncPage/>}/>
                <Route path='captured-images' element={<CapturedImagesPage/>}/>
                <Route path='expenses' element={<ExpensesPage/>}/>
                <Route path='daily-report' element={<DailyReportPage/>}/>
                <Route path='org-settings' element={<OrganizationSettingsPage/>}/>
                <Route path='ui-settings' element={<UISettingsPage/>}/>
                <Route path='weighbridge-setup' element={<WeighbridgeSetupPage/>}/>
                <Route path='wifi-settings' element={<WifiSettingsPage/>}/>

                {/* Sale Entry Routes */}
                <Route path='sale-new' element={<SaleEntryPage/>}/>
                <Route path='sale-new/new' element={<SaleEntryPage/>}/>
                <Route path='sale-new/edit/:id' element={<SaleEntryPage/>}/>
                <Route path='sale-new/view/:id' element={<SaleEntryPage/>}/>
                <Route path='sale-print/:id' element={<SalePrintSummaryPage/>}/>
                {/* 2-Step Sale Entry Routes */}
                <Route path='sale-step1' element={<SaleEntryStep1Page/>}/>
                <Route path='pending-sales' element={<PendingSalesPage/>}/>

                {/* Purchase Entry Routes */}
                <Route path='purchases-list' element={<PurchasesListPage/>}/>
                <Route path='purchase-new' element={<PurchaseEntryPage/>}/>
                <Route path='purchase-new/new' element={<PurchaseEntryPage/>}/>
                <Route path='purchase-new/edit/:id' element={<PurchaseEntryPage/>}/>
                <Route path='purchase-new/view/:id' element={<PurchaseViewPage/>}/>
                <Route path='purchase-print/:id' element={<PurchasePrintSummaryPage/>}/>
                {/* 2-Step Purchase Entry Routes */}
                <Route path='purchase-step1' element={<PurchaseEntryStep1Page/>}/>
                <Route path='pending-purchases' element={<PendingPurchasesPage/>}/>
                {/* QR Auto-Purchase */}
                <Route path='qr-auto-purchase-vehicles' element={<QrAutoPurchaseVehiclesPage/>}/>
                <Route path='qr-scan-log' element={<QrScanLogPage/>}/>
                <Route path='draft-purchases' element={<DraftPurchasesPage/>}/>

                {/* Stock Yard */}
                <Route path='stockyard' element={<StockYardPage/>}/>

                {/* Help Routes */}
                <Route path='help' element={<HelpPage/>}/>
                <Route path='help/:pageId' element={<HelpPage/>}/>

                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
};

export {PrivateRoutes}
